import store, {types as storeTypes} from '../vuex'

import axios from 'axios'

import layer from '../assets/js/layer'

import router from '../router'
import au from '../modules/account/auth'

/**
 * config可配置参数
 * [hideError=false] 隐藏出错弹窗
 */
axios.interceptors.request.use(
    (config) => {
        //console.log("request:", config);
        store.commit(storeTypes.UPDATE_LOADING, true);
        config.mask !== false && store.commit(storeTypes.UPDATE_MASK, true);
        return config
    });

// 成功回调
axios.interceptors.response.use(
    (res) => {
        store.commit(storeTypes.UPDATE_LOADING, false);
        let {data, config} = res.response || res;
        config.mask !== false && store.commit(storeTypes.UPDATE_MASK, false);

        if (data.serverTime) {
            store.commit(storeTypes.SET_SERVER_TIME, data.serverTime)
        }

        return res
    });

// 失败回调（分开写是因为这里还可以顺便处理从成功回调传来的reject）
axios.interceptors.response.use(null,
    (res) => {
        store.commit(storeTypes.UPDATE_LOADING, false);

        let {data, status, statusText, config} = res.response || res;

        config.mask !== false && store.commit(storeTypes.UPDATE_MASK, false);

        if (data.serverTime) {
            store.commit(storeTypes.SET_SERVER_TIME, data.serverTime)
        }


        if (config.handleError === false) {
            return Promise.reject(res)
        }


        let isZyData = verifyZyData(data);
        let requireAuth = status === 401 || data.errorCode === 401;

        switch (true) {
            case requireAuth:
                return auth(res);

            // 出错提醒
            case !config.hideError:
                let msg = isZyData ? data.errorMsg : `${status}, ${statusText}`;
                if (data.data && data.data.traceId) {
                    msg += `[${data.data.traceId}]`
                }
                layer.alert(msg || '未知错误', '出错了', {
                    confirmButtonText: '知道了',
                    callback: action => {
                    }
                });
                break;

            default:
            //
        }

        return new Promise(() => {
        });
        // return res;
    });

/**
 * 验证是否是 zy 的规范
 * @param data
 * @returns {*|boolean}
 */
function verifyZyData(data) {
    return data && ('success' in data)
}

/**
 * 授权
 * @param data
 * @param config
 */
function auth(res) {
    return new Promise((resolve, reject) => {
        au.authRequired({
            router: router.replace,
            route: router.currentRoute,
            ajax: true,
            success: () => {
                //retry the last request
                axios.request(res.config).then(resolve).catch(reject);
            }
        });
    })
}



// WEBPACK FOOTER //
// ./src/api/interceptors.js